<template>
  <a :href="googleMapAddress" target="_blank" class="router-link-newtab">{{displayAddress}}</a>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'LinkGoogleMap',
  props: {
    fullAddress: String,

    address1: String,
    address2: String,
    suburb: String,
    postcode: String,
    state: String,
    country: String
  },
  computed: {
    googleMapAddress() {
      let line = _.compact([this.suburb, this.postcode, this.state]).join(', ')
      let addressList = _.compact([this.address1, this.address2, line, this.country])

      if(this.fullAddress && !this.address1)
        addressList = [this.fullAddress]

      let googleURL = 'http://maps.google.com?q='

      return googleURL + addressList.join(',')
    },
    displayAddress() {
      // Display. Ignore country
      let line = _.compact([this.suburb, this.postcode, this.state]).join(', ')
      let addressList = _.compact([this.address1, this.address2, line])

      if(this.fullAddress && !this.address1)
        addressList = [this.fullAddress]

      return addressList.join(', ')
    }
  }
}
</script>
